// extracted by mini-css-extract-plugin
module.exports = {"fullHeightContainer":"HomePageSeedComponent_fullHeightContainer__1tOvk","flexRow":"HomePageSeedComponent_flexRow__3nKUV","staticRow":"HomePageSeedComponent_staticRow__3LGW0"};